import { z } from 'zod';

export const LOGO_NAMES = z.enum([
  'apple-pay',
  'compassion',
  'compassion-explorer',
  'compassion-journey',
  'compassion-moments',
  'compassion-simple',
  'compassion-sunday',
  'compassion-experience',
  'skippy',
  'compassion-accelerators',
  'compassion-accelerators-text',
  'compassion-advocacy-partners',
  'compassion-builders-wordmark-center-black',
  'compassion-builders-wordmark-center-darkgreen',
  'compassion-builders-wordmark-center-lightgreen',
  'compassion-builders-wordmark-left-black',
  'compassion-builders-wordmark-left-darkgreen',
  'compassion-builders-wordmark-left-lightgreen',
  'compassion-called-to-care',
  'compassion-giving-tuesday',
  'compassion-go-reps',
  'compassion-multipliers',
  'compassion-multipliers-text',
  'compassion-nurturers',
  'compassion-nurturers-wordmark-solo-black',
  'compassion-nurturers-wordmark-solo-midpink',
  'compassion-nurturers-wordmark-solo-lightpink',
  'compassion-nurturers-wordmark-solo-darkpink',
  'compassion-nurturers-wordmark-center-black',
  'compassion-nurturers-wordmark-center-midpink',
  'compassion-nurturers-wordmark-center-lightpink',
  'compassion-nurturers-wordmark-center-darkpink',
  'compassion-nurturers-wordmark-left-black',
  'compassion-nurturers-wordmark-left-midpink',
  'compassion-nurturers-wordmark-left-lightpink',
  'compassion-nurturers-wordmark-left-darkpink',
  'compassion-nurturers-wordmark-tag-darkpink',
  'compassion-nurturers-wordmark-tag-lightpink',
  'compassion-nurturers-text',
  'compassion-responders',
  'compassion-responders-text',
  'compassion-unto-jesus',
  'compassion-vr',
  'k-m-circle',
  'practicing-the-way',
  'trust-charity-watch',
  'trust-ecfa',
  'trust-bbb',
  'trust-guide-star',
  'trust-charity-navigator',
  'trust-norton',
  'trust-seal-of-transparency-guide-star',
]);

export type LogoName = z.infer<typeof LOGO_NAMES>;
